import React, { ReactElement } from 'react';
import Tippy from '@tippyjs/react';

interface HumanogramaLinkProps {
  id?: string;
  name?: string;
  data?: any;
  children: ReactElement | undefined;
}

const Humanograma: React.FC<HumanogramaLinkProps> = ({ data, children }) => {
  return (
    <Tippy
      allowHTML={true}
      content={
        <>
          <p className="m-0">
            Nome: <strong>{data?.nome}</strong>
          </p>
          <p className="m-0">
            Função: <strong>{data?.funcao}</strong>
          </p>
          {data?.diretoria ? (
            <p className="m-0">
              Área: <strong>{data?.diretoria}</strong>
            </p>
          ) : null}
          {data?._id ? (
            <p className="mt-2">
              <strong>{data?._id}</strong>
            </p>
          ) : null}
        </>
      }
    >
      {children}
    </Tippy>
  );
};

export default Humanograma;
